import { render, staticRenderFns } from "./CharVideo.vue?vue&type=template&id=b600022e&scoped=true&"
import script from "./CharVideo.vue?vue&type=script&lang=js&"
export * from "./CharVideo.vue?vue&type=script&lang=js&"
import style0 from "./CharVideo.vue?vue&type=style&index=0&id=b600022e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b600022e",
  null
  
)

export default component.exports